export default "__VITE_ASSET__2bb8e709__"